// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sales-table-container {
  padding: 20px;
  max-width: 100%;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.table-header h3 {
  margin: 0;
  font-size: 1.5rem;
  color: #333;
}

.download-button {
  padding: 8px 16px;
  background-color: #4CAF50;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s;
}

.download-button:hover {
  background-color: #45a049;
}

.table-wrapper {
  overflow-x: auto;
  margin-bottom: 20px;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.sales-table {
  width: 100%;
  border-collapse: collapse;
  white-space: nowrap;
  background-color: white;
}

.sales-table th,
.sales-table td {
  padding: 12px 8px;
  border: 1px solid #ddd;
  text-align: right;
}

.sales-table th:nth-child(-n+3),
.sales-table td:nth-child(-n+3) {
  text-align: left;
}

.sales-table thead tr {
  background-color: #f5f5f5;
}

.sales-table thead th {
  font-weight: 600;
  color: #333;
}

.sales-table tbody tr:hover {
  background-color: #f9f9f9;
}

.sales-table td:not(:empty):before {
  opacity: 0.5;
}

.download-buttons {
  display: flex;
  gap: 1rem;
}

.download-button.txt {
  background-color: #6f42c1;
}

.download-button.txt:hover {
  background-color: #553098;
}
`, "",{"version":3,"sources":["webpack://./src/css/SalesTable.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".sales-table-container {\n  padding: 20px;\n  max-width: 100%;\n}\n\n.table-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.table-header h3 {\n  margin: 0;\n  font-size: 1.5rem;\n  color: #333;\n}\n\n.download-button {\n  padding: 8px 16px;\n  background-color: #4CAF50;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.3s;\n}\n\n.download-button:hover {\n  background-color: #45a049;\n}\n\n.table-wrapper {\n  overflow-x: auto;\n  margin-bottom: 20px;\n  border-radius: 4px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.sales-table {\n  width: 100%;\n  border-collapse: collapse;\n  white-space: nowrap;\n  background-color: white;\n}\n\n.sales-table th,\n.sales-table td {\n  padding: 12px 8px;\n  border: 1px solid #ddd;\n  text-align: right;\n}\n\n.sales-table th:nth-child(-n+3),\n.sales-table td:nth-child(-n+3) {\n  text-align: left;\n}\n\n.sales-table thead tr {\n  background-color: #f5f5f5;\n}\n\n.sales-table thead th {\n  font-weight: 600;\n  color: #333;\n}\n\n.sales-table tbody tr:hover {\n  background-color: #f9f9f9;\n}\n\n.sales-table td:not(:empty):before {\n  opacity: 0.5;\n}\n\n.download-buttons {\n  display: flex;\n  gap: 1rem;\n}\n\n.download-button.txt {\n  background-color: #6f42c1;\n}\n\n.download-button.txt:hover {\n  background-color: #553098;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
